import { FC } from 'react'
import { useAuth } from 'src/AuthContext'
import { ICurrentDrawing, IDrawing, IDrawingEntry, IAllDrawingEntry, UserType } from 'src/types'
import LottoMarquee from 'src/UIComponents/LottoMarquee'
import PastDrawingsCarousel from 'src/UIComponents/PastDrawings'
import HowToPlayCards from 'src/UIComponents/HowToPlayCards'
import NextDrawingCountdown from 'src/UIComponents/NextDrawCountdown'
import CurrentPools from 'src/UIComponents/CurrentPools'
import UserResults from 'src/UIComponents/UserResults'
import Logo from '../assets/images/egs-logo.png'
import { footerLinks } from 'src/constants'

export const MainScreen: FC<{
  timeRemaining: { days: number; hours: number; minutes: number }
  totalEntriesPermitted: number
  changePage: (page: 'main' | 'tickets') => void
  pastDraws: IDrawing[]
  currentPot: number
  currentDrawing: ICurrentDrawing
  allEntries: IAllDrawingEntry[]
  currentEntries: IDrawingEntry[]
}> = ({
  timeRemaining,
  totalEntriesPermitted,
  pastDraws,
  changePage,
  currentPot,
  currentDrawing,
  allEntries,
  currentEntries,
}) => {
  const { userProfile, logIn } = useAuth()

  const handlePlayNowClick = () => {
    if (userProfile?.type === UserType.AnonymousUser) {
      logIn()
    } else {
      changePage('tickets')
    }
  }

  return (
    <>
      <div className="flex flex-col items-center w-full max-w-[600px] p-6 pb-6">
        {/* Current Draw Section */}
        <div className="text-center w-full relative max-w-[450px]">
          {/* blurcles */}
          <div className="w-64 sm:w-96 h-64 rounded-full bg-[#00FFFF] filter blur-3xl absolute left-0 top-0 -z-0 pointer-events-none opacity-20"></div>
          <div className="w-32 sm:w-48 h-48 rounded-full bg-[#FF21F8] filter blur-3xl absolute right-0 top-6 -z-0 pointer-events-none opacity-20"></div>
          <div className="epic-logo flex flex-col justify-center">
            <img src={Logo} alt='Epic Gala Sweepstakes' className='w-full max-w-[768px] mx-auto h-auto relative z-0 mb-4' />
          </div>
          <div className="flex justify-center gap-1 text-4xl font-bold z-10 relative">
            <LottoMarquee potSize={currentPot} />
          </div>
          <NextDrawingCountdown timeRemaining={timeRemaining} />
          <p className="text-white text-sm sm:text-base font-bold">
            Free ticket* with every{' '}
            <span className="text-lottogreen">100 $GALA</span> burn
          </p>
          <p className='text-lottoblue-400 text-super-tiny text-center mb-8'>
            or AMOE option <a className='text-lottoblue-600 underline hover:no-underline' href={footerLinks.terms} target='_blank' rel="noreferrer">Terms and Conditions</a>
          </p>
        </div>

        <UserResults currentEntries={currentEntries} allWinningDraws={allEntries} drawId={currentDrawing.id} endDate={currentDrawing.endDate} />
        
        {pastDraws.length > 0 &&
          <PastDrawingsCarousel drawings={pastDraws} />
        }
        <CurrentPools currentPotSize={currentPot} />

        <HowToPlayCards timeRemaining={timeRemaining} />
      </div>

      <div 
        style={{transform: 'translateZ(0)'}}
        className="flex flex-col justify-center gap-3 py-6 px-6 sticky bottom-0 left-0 z-20 w-full bg-lottoblue-850 bg-opacity-75 backdrop-blur-sm">
            <button
              onClick={handlePlayNowClick}
              className="w-full sm:max-w-96 mx-auto px-20 py-3.5 shadow-lg text-lg font-black lottoCTA-blue whitespace-nowrap"
            >
              PLAY NOW
            </button>
            <p className="text-lottoblue-400 text-sm text-center">
              {userProfile?.type !== UserType.AnonymousUser && (
                <span>
                  You have{' '}
                  <span className="text-lottogreen font-bold">
                    {totalEntriesPermitted} tickets
                  </span>
                  {' '} to enter
                </span>
              )}
              {userProfile?.type === UserType.AnonymousUser && (
                <span>Login to see your tickets</span>
              )}
            </p>
          </div>
    </>
  )
}
